import * as XLSX from 'xlsx-js-style'

/* Note: colors are in ARGB format */

const leftAlign = { horizontal: "left" }
const rightAlign = { horizontal: "right" }

const setAlignment = (cell, columnCount) => {
    if (cell.r === 0) {
        return {
            vertical: "center",
            horizontal: "left",
            wrapText: '1'
        }
    }
    /**
     * Align the below fields (Comments, Reason For Nominations Not Met, Planned Outage, 
     * Unplanned Outage, Updated By, Updated On) at left in respective screens
     */
    if(![0, 1, 2].includes(cell.c) && cell.c <= (columnCount - 7))
        return rightAlign
    
    return leftAlign
}

const setFontColor = (cell, bottomStartsFrom) => {
    if (cell.r === 0) {
        return { rgb: 'ffffffff' }
    }
        if(bottomStartsFrom && ![1, 2, 3].includes(cell.c)){
        return { rgb: 'ffffffff' }
    }
        if(bottomStartsFrom && [1, 2, 3].includes(cell.c)){
        return { rgb: 'ff01205f' }
    }
}

export const applyStyles = (workSheet, scrName) => {
    const range = XLSX.utils.decode_range((workSheet["!ref"] ?? ""))
    const rowCount = range.e.r
    const columnCount = range.e.c

    for (let i in workSheet) {
        if (typeof (workSheet[i]) != "object") continue;
        let cell = XLSX.utils.decode_cell(i);
        /**
         * Paint pinned bottoms in blue
         * When NGL screen - 4 pinned bottoms will be there
         * When Propane, Butane, Iso-Butane, Normal Butane - 3 pinned bottoms will be there
         */
        let bottomStartsFrom = (cell.r > rowCount -3)
        if(scrName && scrName === 'NGL'){
            bottomStartsFrom = (cell.r >= rowCount -3)
        }
        workSheet[i].s = {
            alignment: {
                ...setAlignment(cell, columnCount)
            },
            font: {
                bold: cell.r === 0,
                sz: '10',
                color: setFontColor(cell, bottomStartsFrom)
            },
            border: {
                right: {
                    style: "thin",
                    color: '000000'
                },
                left: {
                    style: "thin",
                    color: '000000'
                },
                top: {
                    style: "thin",
                    color: '000000'
                },
                bottom: {
                    style: "thin",
                    color: '000000'
                },
            },
        }

        // Set green color for today's row
        if(['nmntn-today',  'nmntn-decimal-today', 'cell-wrap-text nmntn-today', 
            'nmntn-number-today'].includes(workSheet[i].StyleID)){
            workSheet[i].s = {
                ...workSheet[i].s,
                fill: {
                    bgColor: { rgb: 'ffc8efb7' },
                    fgColor: { rgb: 'ffc8efb7' }
                }
            }
        }

        // Number of data rows - 5 + 2 ie; Start footer from here
        if((cell.r === 0) || bottomStartsFrom){
            workSheet[i].s.fill = {
                bgColor: { rgb: 'ff01205f' },
                fgColor: { rgb: 'ff01205f' }
            }
        }
        if(bottomStartsFrom){
            workSheet[i].s.border = {
                right: {
                    style: "thin",
                    color: { rgb: 'ff01205f' }
                },
                left: {
                    style: "thin",
                    color: { rgb: 'ff01205f' }
                },
                top: {
                    style: "thin",
                    color: { rgb: 'ff01205f' }
                },
                bottom: {
                    style: "thin",
                    color: { rgb: 'ff01205f' }
                },
            }
            if(workSheet[i].StyleID === 'nmntn-ftr-light-cover'){
                workSheet[i].s = {
                    font: {
                        color: { rgb: 'ffffffff' }
                    }
                }
            }
            if(workSheet[i].StyleID === 'nmntn-ftr-dark-cover'){
                workSheet[i].s = {
                    font: {
                        color: { rgb: 'ff01205f' }
                    }
                }
                workSheet[i].s.fill = {
                    fgColor: { rgb: 'ff01205f' }
                }
            }
            if(['nmntn-nonedit-number-center', 'nmntn-ftr-light']
                .includes(workSheet[i].StyleID)){
                workSheet[i].s = {
                    font: {
                        color: { rgb: '000000' }
                    },
                    alignment: {
                        vertical: "center",
                        horizontal: "right",
                    }
                }
            }
        }
        // If the cell contains decimal values, then round off to 2 decimal places
        if(['grid-cell-yellow', 'nmntn-nonedit-decimal', 'nmntn-decimal', 'nmntn-decimal-today'
        ].includes(workSheet[i].StyleID)){
            workSheet[i].s = {
                ...workSheet[i].s,
                numFmt: "#,##0.00; (#,##0.00)"
            }
        }
        if(['grid-cell-red', 'nmntn-nonedit-number', 'nmntn-number', 
            'nmntn-nonedit-number-center', 'nmntn-number-today', 'nmntn-ftr-dark-number', 
            'nmntn-ftr-light'].includes(workSheet[i].StyleID)){
                workSheet[i].s = {
                    ...workSheet[i].s,
                    numFmt: "#,##0; (#,##0)"
                } 
            }
    }

    return workSheet
}